import { requestCgi } from "../common/requestCgi";
import { METHOD_TEMPLATES } from "../../../utils/consts";
import { get, has, isObjectLike } from "lodash-es";
const commonBeforeEvalParams = async function (instance, args) {
  const options = get(args, 'options', undefined);
  if (!isObjectLike(options)) {
    return;
  }
  ['page', 'size', 'filter'].forEach(key => {
    if (has(options, key)) {
      instance[key] = options[key];
    }
  });
};
export const listCount = async function listCount(params) {
  var _params$excludeCgiMap, _params$request;
  const disabledCount = ((_params$excludeCgiMap = params.excludeCgiMap) === null || _params$excludeCgiMap === void 0 ? void 0 : _params$excludeCgiMap.count) === true;
  const [listResult, countResult] = await Promise.all([requestCgi({
    cgiName: 'list',
    instance: this,
    params
  }), disabledCount ? Promise.resolve(null) : requestCgi({
    cgiName: 'count',
    instance: this,
    params
  }, {
    query: {
      filter: (_params$request = params.request) === null || _params$request === void 0 || (_params$request = _params$request.query) === null || _params$request === void 0 ? void 0 : _params$request.filter
    }
  })]);
  if (listResult.success) {
    this.listData = get(listResult.body, this.protocol.LIST);
  }
  if (countResult !== null && countResult !== void 0 && countResult.success) {
    this.total = get(countResult.body, this.protocol.TOTAL);
  }
  // 保持和代码模式的返回值一致，把success删了
  // @ts-ignore
  delete listResult.success;
  if (countResult && has(countResult, 'success')) {
    // @ts-ignore
    delete countResult.success;
  }
  return {
    listResult,
    countResult
  };
};
listCount.template = [METHOD_TEMPLATES.list.listCount];
listCount.beforeEvalParams = commonBeforeEvalParams;
export const list = async function list(params) {
  const res = await requestCgi({
    cgiName: 'list',
    instance: this,
    params
  });
  if (res.success) {
    this.listData = get(res.body, this.protocol.LIST);
    const total = get(res.body, this.protocol.LIST_TOTAL);
    if (typeof total === 'number') {
      this.total = total;
    }
  }
  return res.body;
};
list.template = [METHOD_TEMPLATES.list.list];
list.beforeEvalParams = commonBeforeEvalParams;
export const count = async function count(params) {
  const res = await requestCgi({
    cgiName: 'count',
    instance: this,
    params
  });
  if (res.success) {
    this.total = get(res.body, this.protocol.TOTAL);
  }
  return res.body;
};
count.template = [METHOD_TEMPLATES.list.count];
count.beforeEvalParams = async function (instance, args) {
  const options = get(args, 'options', undefined);
  if (!isObjectLike(options)) {
    return;
  }
  if (has(options, 'filter')) {
    instance.filter = options.filter;
  }
};
//# sourceMappingURL=listCount.js.map
